export default __webpack_public_path__ + "static/media/subtract_bg.322992f9.svg";